export const timestampToText = (timestamp: number | string) => {
  const built_date = new Date(timestamp)
  return `${built_date.getFullYear()}年${built_date.getMonth() + 1}月`
}
